module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/063-japan-5935487ee1d88564d78465c861f34abf.svg";